module.exports = __webpack_public_path__ + "static/timbrat-dae401178adc5e2a8eb8fc95085a0a06.png";